import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ReviewCard.module.scss";

interface ReviewCardProps {
  name: string;
  text: string;
  rating: number;
}

const ReviewCard: React.FC<ReviewCardProps> = ({ name, text, rating }) => {
  const { t } = useTranslation("common");

  return (
    <div className={styles.reviewCard}>
      <div className={styles.reviewText}>
        <p>{text}</p>
      </div>
      <div className={styles.reviewFooter}>
        <div
          className={styles.stars}
          role="img"
          aria-label={t("feedback.ratingSummary", { rating: rating, total: 5 })}
        >
          {Array.from({ length: 5 }, (_, index) =>
            index < rating ? (
              <img
                key={index}
                src="/images/star-full.svg"
                alt=""
                width="25"
                height="25"
                className={styles.starIcon}
                aria-hidden="true"
              />
            ) : (
              <img
                key={index}
                src="/images/star-empty.svg"
                alt=""
                width="25"
                height="25"
                className={styles.starIcon}
                aria-hidden="true"
              />
            )
          )}
        </div>
        <div className={styles.reviewAuthor}>{name}</div>
      </div>
    </div>
  );
};

export default ReviewCard;
